import React from 'react';
import { IIconProps } from './utils';

export const TeacherComment = ({ fill = 'currentColor', ...rest }: IIconProps) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M12.6667 2H3.33333C2.59695 2 2 2.59431 2 3.32743V13.6675C2 13.9812 2.39679 14.1198 2.59362 13.8748L4.4665 11.5441C4.59302 11.3866 4.78456 11.295 4.98708 11.295H12.6667C13.403 11.295 14 10.7007 14 9.96753V3.32743C14 2.59431 13.403 2 12.6667 2Z"
      stroke={fill}
      strokeWidth="1.33333"
    />
    <path
      d="M5.99935 6.99967C5.99935 7.36786 5.70087 7.66634 5.33268 7.66634C4.96449 7.66634 4.66602 7.36786 4.66602 6.99967C4.66602 6.63148 4.96449 6.33301 5.33268 6.33301C5.70087 6.33301 5.99935 6.63148 5.99935 6.99967Z"
      fill={fill}
    />
    <path
      d="M8.66602 6.99967C8.66602 7.36786 8.36754 7.66634 7.99935 7.66634C7.63116 7.66634 7.33268 7.36786 7.33268 6.99967C7.33268 6.63148 7.63116 6.33301 7.99935 6.33301C8.36754 6.33301 8.66602 6.63148 8.66602 6.99967Z"
      fill={fill}
    />
    <path
      d="M11.3327 6.99967C11.3327 7.36786 11.0342 7.66634 10.666 7.66634C10.2978 7.66634 9.99935 7.36786 9.99935 6.99967C9.99935 6.63148 10.2978 6.33301 10.666 6.33301C11.0342 6.33301 11.3327 6.63148 11.3327 6.99967Z"
      fill={fill}
    />
  </svg>
);
